const utils = {
  parseHTMLTableFromFundOverviewSection: () => {
    const tableSection = document.getElementById('fund-overview');
    if (!!tableSection && tableSection.getElementsByTagName('table').length > 0) {
      const tableEl = tableSection.getElementsByTagName('table')[0];
      const rows = tableEl.querySelectorAll('tbody > tr');
      const elements = Array.from(rows).map(row => {
        const cells = Array.from(row.querySelectorAll('td'));
        return {
          [cells[0].textContent.trim()]: cells[1].textContent.trim(),
        };
      });
      return elements.find(x => x.ISIN);
    }
    return null;
  },

  parseHTMLTableFromListingSection: () => {
    const tableSection = document.getElementById('fund-listing-codes');
    if (!!tableSection && tableSection.getElementsByTagName('table').length > 0) {
      const tableEl = tableSection.getElementsByTagName('table')[0];
      const columns = Array.from(tableEl.querySelectorAll('th')).map(it => it.textContent);
      const rows = tableEl.querySelectorAll('tbody > tr');
      const elements = Array.from(rows).map(row => {
        const cells = Array.from(row.querySelectorAll('td'));
        return columns.reduce((obj, col, idx) => {
          // eslint-disable-next-line no-param-reassign
          obj[col] = cells[idx].textContent;
          return obj;
        }, {});
      });
      return elements.find(x => x.ISIN);
    }
    return null;
  },
  roundToDecimals: (value, decimals = 3) => {
    if (typeof value !== 'number' || Number.isNaN(value)) {
      return null;
    }
    const factor = 10 ** decimals;
    return Math.round(value * factor) / factor;
  },
  roundToPercentage: value => {
    if (typeof value !== 'number' || Number.isNaN(value)) {
      return null;
    }
    return (value * 100).toFixed(2);
  },
  getFirstAndLastDates: data => {
    if (!Array.isArray(data) || data.length === 0) {
      return [null, null];
    }

    const sortedData = data
      .map(d => ({ ...d, cobDate: new Date(d.cobDate) })) // ensure Date objects
      .sort((a, b) => a.cobDate - b.cobDate);

    const firstDate = sortedData[0].cobDate;
    const latestDate = sortedData[sortedData.length - 1].cobDate;

    return [firstDate, latestDate];
  },
};

export default utils;
